module.exports = __webpack_public_path__ + "img/brown-glow.e4732692.svg";